<script setup lang="ts">
/**
 * Huelle der Anwendung: die jeweilige Route und darunter die Fussleiste.
 *
 * Die Fussleiste steht ausserhalb der Route, damit Impressum und Datenschutz
 * von ueberall erreichbar bleiben -- auch von den Rechtstexten selbst.
 */
import { RouterView } from 'vue-router';
import SiteFooter from '@/components/SiteFooter.vue';
</script>

<template>
  <RouterView />
  <SiteFooter />
</template>
